import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FiMail, FiArrowLeft } from 'react-icons/fi';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (data.success) {
        setSubmitted(true);
        toast.success(data.message || 'Password reset email sent! Please check your inbox.');
      } else {
        toast.error(data.message || 'Failed to send password reset email.');
      }
    } catch (error) {
      console.error('Password reset error:', error);
      toast.error('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  if (submitted) {
    return (
      <div className="forgot-password-container">
        <div className="forgot-password-background">
          <div className="forgot-password-card">
            <div className="forgot-password-header">
              <div className="logo-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="120" height="36" viewBox="0 0 98 29.485">
                  <g transform="translate(-52 -39.515)">
                    <g transform="translate(-403 -140)">
                      <rect className="logo-square" width="12" height="12" rx="3" transform="translate(455 182)"></rect>
                      <rect className="logo-square" width="12" height="12" rx="3" transform="translate(455 197)"></rect>
                      <rect className="logo-square" width="12" height="12" rx="3" transform="translate(476 179.515) rotate(45)"></rect>
                      <rect className="logo-square" width="12" height="12" rx="3" transform="translate(470 197)"></rect>
                    </g>
                  </g>
                </svg>
              </div>
              <h1>Check Your Email</h1>
              <p>We've sent a password reset link to {email}</p>
            </div>

            <div className="success-message">
              <div className="success-icon">✓</div>
              <p>If you don't see the email, check your spam folder or try again.</p>
            </div>

            <div className="forgot-password-actions">
              <button
                type="button"
                onClick={handleBackToLogin}
                className="back-to-login-button"
              >
                <FiArrowLeft />
                Back to Login
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-background">
        <div className="forgot-password-card">
          <div className="forgot-password-header">
            <div className="logo-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="120" height="36" viewBox="0 0 98 29.485">
                <g transform="translate(-52 -39.515)">
                  <g transform="translate(-403 -140)">
                    <rect className="logo-square" width="12" height="12" rx="3" transform="translate(455 182)"></rect>
                    <rect className="logo-square" width="12" height="12" rx="3" transform="translate(455 197)"></rect>
                    <rect className="logo-square" width="12" height="12" rx="3" transform="translate(476 179.515) rotate(45)"></rect>
                    <rect className="logo-square" width="12" height="12" rx="3" transform="translate(470 197)"></rect>
                  </g>
                </g>
              </svg>
            </div>
            <h1>Forgot Password?</h1>
            <p>Enter your email address and we'll send you a link to reset your password.</p>
          </div>

          <form onSubmit={handleSubmit} className="forgot-password-form">
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <div className="input-wrapper">
                <FiMail className="input-icon" />
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  className="form-input"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading || !email}
              className="reset-button"
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>

          <div className="forgot-password-actions">
            <button
              type="button"
              onClick={handleBackToLogin}
              className="back-to-login-button"
            >
              <FiArrowLeft />
              Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword; 